<template>
    <div class="wrap">
        <div class="title">
            <div class="title_left">溯源预警
                <el-popover placement="right" width="700" trigger="hover" popper-class="cc-popover">
                    <i slot="reference" class="el-icon-warning warning-icon-el"></i>
                    {{ tip }}
                </el-popover>
            </div>
        </div>
        <div class="innerBox">
            <div class="page-card mt20 clear_a">
                <div>
                    <p class="number">{{ewNumSummary.processedNum}}</p>
                    <p class="text">已经处理预警数</p>
                </div>
                <div>
                    <p class="number">{{ewNumSummary.currentNum}}</p>
                    <p class="text">当前预警数</p>
                </div>
                <div>
                    <p class="number">{{ewNumSummary.totalScore}}</p>
                    <p class="text">扣分上限</p>
                </div>
                <div>
                    <p class="number">{{ewNumSummary.actualDeduction}}</p>
                    <p class="text">实际总扣分</p>
                </div>
            </div>
            <div class="ipt-btn-box">
                <el-input placeholder="处理人" class="w250 mr20 seekIpt" v-model="tableLimit.handlePerson" @keyup.enter.native="changeSearch">
                    <i slot="suffix" class="el-input__icon el-icon-search" @click="changeSearch"></i>
                </el-input>
                <el-select class="mr20" v-model="tableLimit.handleStatus" @change="changeSearch" placeholder="处理状态" clearable>
                    <el-option v-for="item in statusOptions" :key="item.key" :label="item.value" :value="item.key">
                    </el-option>
                </el-select>
                <el-select class="mr20" v-model="tableLimit.handleType" @change="changeSearch" placeholder="处理方式" clearable>
                    <el-option v-for="item in methodOptionsArr" :key="item.key" :label="item.value" :value="item.key">
                    </el-option>
                </el-select>
                <el-select class="mr20" v-model="tableLimit.handleDept" @change="changeSearch" placeholder="处理部门" clearable>
                    <el-option v-for="item in deptOptionsArr" :key="item.key" :label="item.value" :value="item.key">
                    </el-option>
                </el-select>
                <el-select class="mr20" v-model="tableLimit.anomalyType" @change="changeSearch" placeholder="异常类型" clearable>
                    <el-option v-for="item in typeOptions" :key="item.key" :label="item.value" :value="item.key">
                    </el-option>
                </el-select>

            </div>
            <div class="ipt-btn-box">
                <div style="display: inline-block;">
                    预警日期：
                    <el-date-picker :picker-options="pickerOptions0" v-model="tableLimit.month" @change="changeSearch(null, true)" type="month"
                                    value-format="yyyy-MM" placeholder="预警日期" class="ml10 mr10 w140"></el-date-picker>
                </div>
                <el-checkbox v-model="tableLimit.penalties" @change="changeSearch" style="line-height:34px;">
                    仅显示扣分项
                </el-checkbox>
            </div>
            <div class="table">
                <el-table v-loading="loading" element-loading-text="数据正在努力加载中" :border="true" :resizable="true" :data="tableData" class="table-div">
                    <el-table-column type="index" label="序号" width="50"></el-table-column>
                    <el-table-column show-overflow-tooltip min-width="100" label="溯源异常月份">
                      <template slot-scope="scope">
                        {{ scope.row.warningDate && scope.row.warningDate.slice(0, 10) }}
                      </template>
                    </el-table-column>
                    <!-- <el-table-column show-overflow-tooltip prop="" min-width="100" label="当月溯源率"></el-table-column> -->
                    <el-table-column show-overflow-tooltip prop="warningTypeStr" min-width="100" label="问题描述"></el-table-column>
                    <el-table-column show-overflow-tooltip prop="warningDate" min-width="100" label="预警时间"></el-table-column>
                    <el-table-column show-overflow-tooltip prop="shouldDeduction" min-width="100" label="应扣分"></el-table-column>
                    <el-table-column show-overflow-tooltip prop="deduction" min-width="100" label="实扣分"></el-table-column>
                    <el-table-column show-overflow-tooltip prop="handleStatusStr" min-width="100" label="处理状态"> </el-table-column>
                    <el-table-column show-overflow-tooltip prop="handleTypeStr" min-width="100" label="处理方式"> </el-table-column>
                    <el-table-column show-overflow-tooltip prop="handleDeptStr" min-width="100" label="处理部门"> </el-table-column>
                    <el-table-column show-overflow-tooltip prop="handlePerson" min-width="100" label="处理人"></el-table-column>
                    <el-table-column show-overflow-tooltip prop="handleTime" min-width="100" label="处理时间"></el-table-column>
                    <el-table-column show-overflow-tooltip prop="handleRemark" min-width="100" label="处理备注"></el-table-column>
                    <el-table-column min-width="120" label="处理附件">
                        <template slot-scope="scope">
                            <div v-if='scope.row.urlList_.length>0' style="width: 100px; height: 100px">
                                <el-image style="width: 100px; height: 100px" :src="scope.row.urlList_[0]" :preview-src-list="scope.row.urlList_">
                                </el-image>
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column label="操作" min-width="200" fixed="right">
                        <template slot-scope="scope">
                            <a href="javascript:;" class="operate-a" v-if="scope.row.handleStatus == '1'"
                               @click="dispose('review',scope.row)">重新处理</a>
                            <a href="javascript:;" class="operate-a" v-else @click="dispose('dispose',scope.row)">处理</a>
                        </template>
                    </el-table-column>
                </el-table>
                <div class="pagination-box">
                    <el-pagination background @size-change="pageSizeChange" @current-change="pagecCurrentChange" :current-page="tableLimit.current"
                                   :page-sizes="[10, 20, 30, 40,50]" :page-size="tableLimit.size" layout="total, sizes, prev, pager, next, jumper"
                                   :total="total">
                    </el-pagination>
                </div>
                <Dialog :dialogData="dialogData" url="/early/warning/origin/handle" :showTip="disposeAddDialog" v-if="disposeAddDialog" disposeType='02'
                        @refresh="disposeRefresh" :isAssess="true" @cancel="closeDialog" :handle="methodOptionsArr">
                </Dialog>
            </div>
        </div>
    </div>

</template>

<script>
import Dialog from "./public/disposeDialog";
import * as api from 'api/warning_v3.js';

export default {
    components: { Dialog },
    async mounted() {
        this.tableLimit.entityId = this.$store.state.common.user.deptId;
        this.dataEdit();
        if (this.$route.query.handleStatus) {
            this.tableLimit.handleStatus = this.$route.query.handleStatus * 1;
        }

        // 默认日期 （当前月）
        let dateNow = new Date();
        let year = dateNow.getFullYear();
        let month = ('00' + (dateNow.getMonth() + 1)).slice(-2)
        this.tableLimit.month = `${year}-${month}`
        
        this.schoolTraceBaseUrl = this.$store.state.common.baseUrl;
        this.initSelectData();
        this.searchPage();
        this.getEwNumSummary();

        api.getHint({ warningType: this.warningType, entityId: this.tableLimit.entityId })
            .then(data => {
                if (data.code == 200) {
                    this.tip = data.data;
                }
            })
    },
    methods: {
        initSelectData() {
            // 获取处理状态
            api.getHandleStatus()
                .then(data => {
                    if (data.code === 200) {
                        this.statusOptions = data.data;
                        this.statusOptions_ = this.array2Object(this.statusOptions);
                    }
                });

            // 获取 处理方式
            api.getHandleType({ warningType: this.warningType })
                .then(data => {
                    if (data.code === 200) {
                        this.methodOptionsArr = data.data;
                        this.methodOptions_ = this.array2Object(this.methodOptionsArr);
                    }
                });

            // 获取 处理部门
            api.getHandleDept()
                .then(data => {
                    if (data.code === 200) {
                        this.deptOptionsArr = data.data;
                        this.deptOptions_ = this.array2Object(this.deptOptionsArr);
                    }
                });

            // 获取 异常类型
            api.getType({ parentCode: this.warningType })
                .then(data => {
                    if (data.code === 200) {
                        this.typeOptions = data.data;
                        this.typeOptions_ = this.array2Object(this.typeOptions);
                    }
                });
        },
        // [{value: '', key: ''}] => {key: value}
        array2Object(arr = []) {
            let obj = {};

            arr.forEach(item => {
                obj[item.key] = item.value;
            })

            return obj;
        },
        // {key: value} => [{value: '', key: ''}]
        object2Array(obj = {}) {
            let arr = [];

            Object.keys(obj).forEach(key => {
                arr.push({ value: obj[key], key: key });
            })

            return arr;
        },
        getEwNumSummary() {
            let data = {
                entityId: this.tableLimit.entityId,
                warningMonth: this.tableLimit.month,
                warningType: this.warningType,
            }
            api.getDetailStatistics(data)
                .then(data => {
                    if (data.code === 200) {
                        Object.assign(this.ewNumSummary, data.data);
                    }
                })
        },
        dataEdit() {
            this.methodOptionsArr = [];
            this.deptOptionsArr = []
            for (let i in this.methodOptions) {
                this.methodOptionsArr.push({
                    label: this.methodOptions[i],
                    value: i
                });
            }
            for (let i in this.deptOptions) {
                this.deptOptionsArr.push({
                    label: this.deptOptions[i],
                    value: i
                });
            }
        },
        async searchPage() {
            this.loading = true;
            let data = { ...this.tableLimit };
            if (this.tableLimit.penalties === true) {
                data.penalties = 'YES';
            } else if (this.tableLimit.penalties === false) {
                data.penalties = "NO";
            } else {
                data.penalties = "";
            }

            let result = await api.getOriginDetailList(data);

            if (result.code == 200) {
                this.tableData = [];
                result.data.records.map(item1 => {
                    if (item1.handAnnex && item1.handAnnex.length > 0) {
                        let arr = item1.handAnnex.map(item => this.schoolTraceBaseUrl + "/" + item.fileUrl)
                        this.$set(item1, 'urlList_', arr)
                    } else {
                        this.$set(item1, 'urlList_', [])
                    }
                    this.tableData.push(item1)
                })
                this.total = result.data.total
            }
            this.loading = false;
        },
        changeSearch(e, searchEwNumSummary = false) {
            this.tableLimit.current = 1;
            this.searchPage();
            searchEwNumSummary && this.getEwNumSummary();
        },
        pagecCurrentChange(num) {
            this.tableLimit.current = num;
            this.searchPage();
        },
        pageSizeChange(size) {
            this.tableLimit.size = size;
            this.changeSearch();
        },
        disposeRefresh() {
            this.searchPage();
            this.getEwNumSummary();
        },
        dispose(type, row) {
            if (type == "review") {
                this.dialogData.title = "重新处理";
                this.dialogData.handleRemark = row.handleRemark;
                this.dialogData.handlePersonName = row.handlePersonName;
                this.dialogData.fidList = row.urlList;
            } else if (type == "dispose") {
                this.dialogData.title = "预警处理";
            }
            this.dialogData.id = row.id;
            this.dialogData.warningType = row.warningType;
            this.dialogData.warningId = row.id;
            this.dialogData.entityId = this.tableLimit.entityId;
            this.dialogData.warningDate = row.warningDate;
            this.disposeAddDialog = true;
        },
        closeDialog() {
            this.disposeAddDialog = false;
        }
    },
    data() {
        return {
            warningType: '0102',
            tip: '',
            total: 0,
            loading: false,
            tableData: [],
            schoolTraceBaseUrl: '',
            ewNumSummary: {
                actualDeduction: 0,
                currentNum: 0,
                processedNum: 0,
                totalScore: 0,
            },
            tableLimit: {
                anomalyType: '',
                entityId: "",
                current: 1,
                size: 10,
                month: "",
                handleStatus: "",
                handleType: "",
                handleDept: "",
                handlePerson: "",
                penalties: '',
            },
            statusOptions: [],
            statusOptions_: {},
            typeOptions: [],
            typeOptions_: {},
            methodOptionsArr: [],
            methodOptions_: {},
            deptOptionsArr: [],
            deptOptions_: {},
            pickerOptions0: {
                disabledDate: time => {
                    let endDate = new Date(this.tableLimit.endDate);
                    let date = new Date("2018-12-31");
                    if (this.tableLimit.endDate) {
                        return time.getTime() > endDate || time.getTime() < date || time.getTime() > Date.now() - 8.64e6
                    } else {
                        return time.getTime() < date || time.getTime() > Date.now() - 8.64e6
                    }
                }
            },
            dialogData: {
                id: "",
                title: "",
                handlePerson: "",
                handleRemark: "",
                defaultDeduction: 0,
                fidList: []
            },
            disposeAddDialog: false
        };
    }
};
</script>
<style scoped lang="scss">
.wrap {
    padding: 0 20px;
    width: calc(100% - 40px);
    height: 100%;
    background: #f6f6f6;

    .title {
        height: 60px;
        line-height: 60px;

        .title_left {
            font-size: 20px;
            font-weight: 400;
            color: rgba(51, 51, 51, 1);
            width: 50%;
            height: 100%;
        }
    }

    .innerBox {
        width: calc(100% - 60px);
        padding: 20px 30px;
        min-height: calc(100% - 125px);
        background: #fff;
        border-radius: 10px;
        margin-bottom: 30px;
    }
}

.pagination-box {
    text-align: right;
    margin-top: 20px;
}

.table-div {
    width: 100%;
    text-align: center;
}

.operate-a {
    color: #1787ad;
}

table tr td:last-child .cell a {
    border-right: 1px solid #ccc;
    padding-right: 5px;
}

table tr td:last-child .cell a:last-child {
    border-right: none;
    padding-right: 0px;
}

.page-card {
    height: 100px;
    border: 1px solid rgba(194, 202, 210, 1);

    > div {
        height: 100%;
        width: 25%;
        text-align: center;

        p.number {
            font-size: 28px;
            font-weight: 500;
            color: rgba(57, 57, 57, 1);
            line-height: 40px;
            margin-bottom: 10px;
            margin-top: 10px;
        }

        p.text {
            font-size: 14px;
            font-weight: 400;
            color: rgba(162, 170, 182, 1);
            line-height: 20px;
        }
    }
}
.dialogImage {
    width: 100%;
    height: 100%;
    position: fixed;
    left: 0;
    top: 0;
}
.ipt-btn-box {
    margin: 20px 0;
}
</style>